// @aiContributed-MAPFuse-2025-12-05
import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';

const DelayedAddMoreAssetsStepWithI18n =
  () => import(/* webpackChunkName: 'campaign-add-more-assets-step.async' */'./add-more-assets-step')
    .then(({ AddMoreAssetsStepWithI18n }) => AddMoreAssetsStepWithI18n);

const DelayedAddMoreAssetsLazyRepository =
  () => import(/* webpackChunkName: 'add-more-assets-lazy-repository.async' */'./add-more-assets-lazy-repository')
    .then(({ AddMoreAssetsLazyRepositoryWithI18n }) => AddMoreAssetsLazyRepositoryWithI18n);

export const SearchCampaignAddMoreAssetsStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.SEARCH_CAMPAIGN_ADD_MORE_ASSETS,
  view: DelayedAddMoreAssetsStepWithI18n,
  repository: DelayedAddMoreAssetsLazyRepository,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
  },
  repositoryProps: {
    isSignup: true,
  },
};
